export default __webpack_public_path__ + "static/media/goaoverview.a1ace064.jpg";